var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 6,
    stroke: "hsl(0, 0%, 100%)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "24.5 17",
    transform: "matrix(1,0,0,1,-74,-63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.31829833984375 229Q593.3182983398438 261 570.3182983398438 571 ",
    markerEnd: "url(#SvgjsMarker2138)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    markerWidth: 5,
    markerHeight: 5,
    refX: 2.5,
    refY: 2.5,
    viewBox: "0 0 5 5",
    orient: "auto",
    id: "SvgjsMarker2138"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,5 0,0 5,2.5",
    fill: "hsl(0, 0%, 100%)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrow);
export default __webpack_public_path__ + "static/media/new_arrow.8a544164dd4785b77e9c42ed3209cac7.svg";
export { ForwardRef as ReactComponent };